import { getMetricType, METRIC_TYPE } from "@/metrics/metric-display"
import type { MetricDirectoryEntry } from "@/metrics/registry"

interface WidgetMetricOutputSource {
  output_type?: string | null
  metric_name?: string
  metric_manager?: string
  metric_metadata?: object | null
}

export function getWidgetMetricOutputType(
  metric: WidgetMetricOutputSource,
  entry?: MetricDirectoryEntry,
): string {
  if (metric.output_type != null) {
    return metric.output_type
  }
  // Legacy definitions use their semantic type, then the backend's numeric default.
  const type = getMetricType(
    {
      ...metric,
      metric_name: metric.metric_name ?? "",
      metric_manager: metric.metric_manager ?? "",
      output_type: undefined,
    },
    entry,
  )
  return type === METRIC_TYPE.BINARY || type === METRIC_TYPE.CATEGORICAL
    ? "string"
    : "float"
}

export function withWidgetMetricOutputTypes<T extends WidgetMetricOutputSource>(
  sources: Record<string, T> | undefined,
  byManager: Record<string, MetricDirectoryEntry> = {},
): Record<string, T> {
  return Object.fromEntries(
    Object.entries(sources ?? {}).map(([id, metric]) => [
      id,
      {
        ...metric,
        output_type: getWidgetMetricOutputType(
          metric,
          byManager[metric.metric_manager ?? ""],
        ),
      },
    ]),
  )
}

export function isWidgetMetricOutputType(
  value: unknown,
): value is "float" | "string" {
  return value === "float" || value === "string"
}
